import {
    ChangeDetectionStrategy,
    Component,
    effect,
    input,
    InputSignal,
    OnDestroy,
    OnInit,
    output,
    OutputEmitterRef,
} from '@angular/core';
import { debounceTime, Subject, Subscription } from 'rxjs';

import { RessourcesModule } from '@ressources/client/ressources.module';

const MINIMUM_SEARCH_LENGTH = 1;
const SEARCH_DEBOUNCE_TIME = 500; // ms

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-custom-search',
    styleUrl: './custom-search.component.scss',
    templateUrl: './custom-search.component.html',
})
export class CustomSearchComponent implements OnInit, OnDestroy {
    public readonly initialValue = input<string>('');
    public readonly isNarrowSearchBar: InputSignal<boolean> = input<boolean>(false);
    public resetSearch: OutputEmitterRef<string> = output<string>();
    public search: OutputEmitterRef<string> = output<string>();
    public searchValue: string = '';

    private searchSubject: Subject<string> = new Subject<string>();
    private searchSubscription: Subscription | null = null;

    public constructor() {
        effect(() => {
            this.searchValue = this.initialValue();
        });
    }

    public clearSearch(): void {
        this.searchValue = '';
        this.onSearchValue();
    }

    public ngOnDestroy(): void {
        this.searchSubscription?.unsubscribe();
    }

    public ngOnInit(): void {
        this.searchSubscription = this.searchSubject
            .pipe(debounceTime(SEARCH_DEBOUNCE_TIME))
            .subscribe((searchTerm) => {
                if (searchTerm.length <= MINIMUM_SEARCH_LENGTH) {
                    this.resetSearch.emit(searchTerm);
                }

                if (searchTerm.length > MINIMUM_SEARCH_LENGTH) {
                    this.search.emit(searchTerm);
                }
            });
    }

    public onSearchValue(): void {
        this.searchSubject.next(this.searchValue);
    }
}
